import {PasswordResetInit} from "./pages/public/PasswordResetInit";
import {PasswordResetFinish} from "./pages/public/PasswordResetFinish";
import {Landing} from "./pages/public/Landing";

export const themeRoutes = [
    {path: '/account/password-reset/init', component: PasswordResetInit, exact: true},
    {path: '/account/password-reset/finish', component: PasswordResetFinish, exact: true},
    {path: '/', component: Landing}, // Inserita come ultima, fix login
];